import React from "react";
import { Box, Button, Typography } from "@mui/material";

interface ApprovalModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
  loading?: boolean;
}

const PendingApprovalConfirmationModal: React.FC<ApprovalModalProps> = ({
  open,
  onClose,
  onSubmit,
  loading = false,
}) => {
  if (!open) return <></>;

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        display: open ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
        pointerEvents: "none",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#fff",
          padding: 3,
          borderRadius: 2,
          minWidth: 300,
          boxShadow: 2,
          zIndex: 10000,
          pointerEvents: "auto",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <Typography variant="h6" gutterBottom>
          Confirm Approval
        </Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Are you sure you want to approve this expense ?
        </Typography>
        <Box display="flex" justifyContent="flex-end" gap={1}>
          <Button variant="outlined" onClick={onClose} size="small">
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={onSubmit}
            size="small"
            disabled={loading}
          >
            {loading ? "Submitting..." : "Submit"}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default PendingApprovalConfirmationModal;
